import { LOCALE_STORAGE_KEYS } from 'config/localStorageKeys';
import { endOfDay } from 'date-fns';

type CachedUser = { id: string; shortId?: number } & Record<string, any>;
type UserMap = Record<string, CachedUser>;

export const getCachedUsers = (): UserMap =>
  JSON.parse(localStorage.getItem(LOCALE_STORAGE_KEYS.USERS_CACHE) || '{}');

export const saveUsersToCache = (users: CachedUser[]) => {
  const map = getCachedUsers();
  users.forEach((u) => {
    if (u.shortId !== undefined) {
      return (map[String(u.shortId)] = u);
    }

    map[u.id] = u;
  });
  localStorage.setItem(LOCALE_STORAGE_KEYS.USERS_CACHE, JSON.stringify(map));
  localStorage.setItem(
    LOCALE_STORAGE_KEYS.USERS_CACHE_EXPIRATION_DATE,
    endOfDay(new Date()).toJSON()
  );
};

export const isUsersCacheActual = () => {
  const exp = localStorage.getItem(
    LOCALE_STORAGE_KEYS.USERS_CACHE_EXPIRATION_DATE
  );
  return exp ? new Date() < new Date(exp) : false;
};
